import { pipelineChangeDetectionLegend, pipelineGreenLegend } from '../config/legends'

const service = {
  name: 'PipelineChangeDetection',
  label: 'Pipeline Change Detection',
  permissionId: 'pipelinechangedetection',
  iconComponent: 'Pipeline',
  showCoordinates: true,
  hideDatetimeSlider: true,
  disableMainDate: true,
  showDissolveClock: true,
  data: [
    {
      id: 'PipelineChangeDetection',
      url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3APipelineChangeDetectionPointData`,
      datetimeId: 'PipelineChangeDetection',
      type: 'point'
    }
  ],
  layers: [
    {
      name: 'PipelineChangeDetection',
      label: 'Pipeine Change Detection',
      open: true,
      opacity: 'fill-opacity',
      datetimeId: 'PipelineChangeDetection',
      secondary: false,
      // datetimeId: 'PipelineGreen',
      legend: {
        type: 'categorical',
        data: pipelineChangeDetectionLegend
      },
      filter: {
        min: -100,
        max: 200,
        value: 0,
        label: '  magnitude change',
        title: 'Change detection',
        transformLabel: ' units',
        transform: value => value,
        transformIn: value => value,
        transformOut: value => value
      }
    },
    {
      name: 'PipelineMask',
      label: 'Pipeline outline',
      opacity: 'raster-opacity',
      hidden: true
    },
    {
      name: 'Sentinel2PipelineChangeDetection',
      // name: 'Sentinel2',
      label: 'Sentinel 2 (10 m)',
      opacity: 'raster-opacity',
      // datetimeId: 'PipelineGreen',
      secondary: false,
      open: true,
      transparencyLabel: 'Date fader',
      transparencyMarks: {
        0: { label: 'May 2017', value: 0 },
        100: { label: 'July 2017', value: 100 }
      },
      hideLabel: true,
      disableToggle: true
    },
    {
      name: 'Sentinel2PipelineChangeDetectionBase',
      // name: 'Sentinel2',
      label: 'Sentinel 2 (10 m)',
      opacity: 'raster-opacity',
      datetimeId: 'PipelineChangeDetectionBase',
      secondary: false,
      hidden: true
    },
    // {
    //   name: 'PipelineGreen',
    //   label: 'Green band',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'PipelineGreen',
    //   legend: {
    //     type: 'categorical',
    //     data: pipelineGreenLegend
    //   }
    // },
  ],
  locations: [
    {
      name: 'Test pipeline',
      latitude: 45.3126,
      longitude: -73.4978,
      zoom: [14],
      maxBounds: [[-73.5436, 45.2967], [-73.4601, 45.3255]],
    },
    // {
    //   name: 'Pipeline',
    //   latitude: 48.513054670113938,
    //   longitude: -71.656869225589588,
    //   zoom: [12]
    // }
  ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/PipelineChangeDetection.js